import { render, staticRenderFns } from "./customerAppOnboarding.vue?vue&type=template&id=2fb6697a&"
import script from "./customerAppOnboarding.vue?vue&type=script&lang=js&"
export * from "./customerAppOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports